module.exports = __webpack_public_path__ + "static/media/hitPlane2.e7dc2d31.wav";